// extracted by mini-css-extract-plugin
export default {"dottedBorderLeft":"pAjoKOwibtPxYWEmjS7g"};